export default function checkUserPreferredColorScheme(mode) {
    const isBrowser = typeof window !== "undefined"
    if (isBrowser) {
        return window.matchMedia(`(prefers-color-scheme: ${mode})`).matches;
    }
}